export default ({ app }) => {
  function redirectToLogin() {
    const from = app.router.currentRoute.fullPath
    app.router.replace({ path: app.localePath("/login"), query: { from } })
  }

  function isAuthOrPermissionError(reason) {
    const code = reason?.code
    const msg = reason?.message || ""

    return (
      // FsLocations guard
      (msg.includes("[FsLocations]") && msg.includes("is required")) ||

      // firebase/store auth errors
      code === "permission-denied" ||
      code === "unauthenticated" ||

      // fallback string matches (sometimes missing code.. smh)
      msg.includes("Missing or insufficient permissions") ||
      msg.includes("permission-denied") ||
      msg.includes("unauthenticated")
    )
  }

  window.addEventListener("unhandledrejection", (event) => {
    if (isAuthOrPermissionError(event.reason)) redirectToLogin()
  })

  window.addEventListener("error", (event) => {
    if (isAuthOrPermissionError(event.error)) redirectToLogin()
  })
}
